import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfig } from 'sigv-library';
import { BackgroundEnum } from '../enums/background.enum';

@Injectable({
  providedIn: 'root',
})
export class BackgroundImageService {
  
  private resizeSubject = new BehaviorSubject<void | null>(null);
  resize$ = this.resizeSubject.asObservable();

  blobUrl = AppConfig.envConfig.iconSrcUrl;
  blobUrlLogin = '';
  blobUrlBg = '';

  constructor() {
    this.setupResizeListener();
    this.updateBackgroundImage();
  }

  /** 設定視窗大小監聽 */
  private setupResizeListener(): void {
    window.addEventListener('resize', () => {
      this.updateBackgroundImage();
    });
  }

  /** 更新背景圖片 */
  private updateBackgroundImage() {
    this.blobUrlLogin = this.blobUrl + BackgroundEnum.LOGIN;

    if (window.innerWidth >= 768) {
      this.blobUrlBg = this.blobUrl + BackgroundEnum.BANNER1920;
    } else {
      this.blobUrlBg = this.blobUrl + BackgroundEnum.BANNER800;
    }

    this.resizeSubject.next();
  }
}
